import { AtomIcon, ConeIcon, FactoryIcon, MountainIcon, ScanSearchIcon, TruckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Cement Manufacturing: Raw Materials, Kiln, Clinker & Grinding',
    summary: 'A visual technical reference to how limestone and clay become Portland cement — raw mix control, preheater, kiln, clinker, cooler, grinding and plant quality.',
    icon: FactoryIcon,
  },
  {
    number: '02',
    title: 'Cement Chemistry, Cement Types & Supplementary Cementitious Materials',
    summary: 'A visual technical reference to clinker phases, hydration, cement families and the SCMs — fly ash, slag, silica fume and calcined clays — that change how concrete behaves.',
    icon: AtomIcon,
  },
  {
    number: '03',
    title: 'Aggregates, Water, Admixtures & Concrete Mix Design',
    summary: 'A visual technical reference to aggregate properties, mixing water, chemical admixtures and the absolute volume mix design method, fully worked.',
    icon: MountainIcon,
  },
  {
    number: '04',
    title: 'Concrete Production, Transport, Placing, Compaction & Curing',
    summary: 'A visual technical reference to batching plants, ready-mix delivery, placing methods, vibration, finishing, hot and cold weather concreting and curing.',
    icon: TruckIcon,
  },
  {
    number: '05',
    title: 'Concrete Testing: Fresh, Hardened, Laboratory & In-Situ',
    summary: 'A visual technical reference to slump, air content, specimens, compressive strength, cement and durability tests, NDT, cores and the maturity method.',
    icon: ConeIcon,
  },
  {
    number: '06',
    title: 'Durability, Defects, Concrete Pathology, Repair & Quality Control',
    summary: 'A visual technical reference to deterioration mechanisms, cracks and surface defects, condition surveys, repair principles and the concrete quality control system.',
    icon: ScanSearchIcon,
  },
];
